// Canonical role values must match backend v2 DB constraint:
// ck_users_role CHECK (role IN ('admin','sales_coordinator','sales','sales_manager'))
export const ROLES = {
  admin: {
    value: 'admin',
    label: 'Admin',
    color: 'bg-red-100 text-red-700 border border-red-200',
    hierarchy: 1,
  },
  sales_manager: {
    value: 'sales_manager',
    label: 'Sales Manager',
    color: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
    hierarchy: 3,
  },
  sales_coordinator: {
    value: 'sales_coordinator',
    label: 'Sales Coordinator',
    color: 'bg-cyan-100 text-cyan-700 border border-cyan-200',
    hierarchy: 2,
  },
  sales: {
    value: 'sales',
    label: 'Sales',
    color: 'bg-blue-100 text-blue-600 border border-blue-200',
    hierarchy: 4,
  },
};

const ROLE_ALIASES = {
  'MD Office': 'admin',
  'Sales Manager': 'sales_manager',
  Manager: 'sales_coordinator',
  Sales: 'sales',
  Admin: 'admin',
  salesCoordinator: 'sales_coordinator',
};

const normalizeRole = (roleValue) => {
  const raw = String(roleValue || '').trim();
  return ROLE_ALIASES[raw] || raw.toLowerCase();
};

// Helper functions for working with roles
export const getRoleOptions = () => {
  return Object.values(ROLES).sort((a, b) => a.hierarchy - b.hierarchy);
};

export const getRoleColor = (roleValue) => {
  const key = normalizeRole(roleValue);
  return ROLES[key]?.color || 'bg-gray-100 text-gray-700 border border-gray-200';
};

export const getRoleLabel = (roleValue) => {
  const key = normalizeRole(roleValue);
  return ROLES[key]?.label || roleValue;
};

export const isValidRole = (roleValue) => {
  const key = normalizeRole(roleValue);
  return key in ROLES;
};

export const getRolesByHierarchy = (level) => {
  return Object.values(ROLES).filter((role) => role.hierarchy === level);
};
